import Config from 'conf';
import bindSocketEvents from './binds';

export default socketMiddleware => {
    bindSocketEvents(socketMiddleware);
    let socketEmit = socketMiddleware.socketEmit.bind(socketMiddleware);
    let socketOn = socketMiddleware.socketOn.bind(socketMiddleware);
    return {
        setEnv: env => {
            return new Promise((resolve, reject) => {
                let setEnvFeedback = args => {
                    if (timeout) {
                        clearTimeout(timeout);
                        timeout = null;
                    }
                    socketMiddleware.off('setEnvFeedback', setEnvFeedback);
                    if (args.success) {
                        return resolve(args.env);
                    } else {
                        return reject(new Error(args.error));
                    }
                };

                socketOn('setEnvFeedback', setEnvFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('setEnvFeedback', setEnvFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('setEnv', { env });
            });
        }
    };
};



// WEBPACK FOOTER //
// ./environments/testbench/eventsSocket/Environment/index.js